/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/10/2023
 */
import React, { useState, useEffect } from "react"
import Header from "../header/Header"
import Sidebar from "../sidebar/Sidebar"
import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import CssBaseline from "@mui/material/CssBaseline"
import api from "../services/AuthApi"

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}))

const Layout = ({ children }) => {
  const [dopen, setdOpen] = useState(true)

  useEffect(() => {
    api
      .get("/settings/SET_AUTO_APPROVE")
      .then((res) => {
        const activeStatus = res.data?.dataList[0].active
         localStorage.setItem("SET_AUTO_APPROVE", JSON.stringify(activeStatus))
      })
      .catch((error) => {})
  }, [])

  const handleDrawerOpen = () => {
    setdOpen(true)
  }

  const handleDrawerClose = () => {
    setdOpen(false)
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Header handleDrawerOpen={handleDrawerOpen} open={dopen} />
      <Sidebar handleDrawerClose={handleDrawerClose} dopen={dopen} />

      <Box component="main" sx={{ flex: "1 1 0%", minWidth: 0, p: { xs: 2, sm: 3 } }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  )
}
export default Layout
